module.exports = __webpack_public_path__ + "static/media/add-description-save-details.55b79da3.gif";